import { render } from "./Webinar.vue?vue&type=template&id=3c4034de&scoped=true"
import script from "./Webinar.vue?vue&type=script&lang=ts"
export * from "./Webinar.vue?vue&type=script&lang=ts"

import "./Webinar.vue?vue&type=style&index=0&id=3c4034de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c4034de"

export default script